<template>
  <div class="bindCar">

    <div class="advertising" style="padding: 2% 1.5%;" v-if="url!=''">
      <img :src="url" @click="clickUrl()" width="100%" height="100%" />
    </div>
    <div class="con">
      <van-cell v-for="item in carList" :key="item" style="margin-bottom: 2%;">
        <div class="div_info">
          <div class="div_left" style="width: 50%;">
            <img style="width: 80%;height:90px;" :src="carImgUrl" />
          </div>
          <div class="div_left" style="width: 30%;">
            <h4>{{carFormat(item.carNum)}}</h4>
            <p class="relieve_bind" @click="relieveBind(item.id)">解除绑定</p>
          </div>
          <div class="div_clear"></div>
        </div>
      </van-cell>
    </div>
    <div v-if="isBind" class="div_msg">
      暂未绑定车辆
    </div>
    <div class="div_info1">
      <van-button v-if="isFullBind" class="bt_bind" color="#f47b20" @click="bindCar">添加绑定</van-button>
      <div class="info">
        <p>最多添加3个车牌</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    Dialog
  } from 'vant';
  import {
    mySessionStorage
  } from '@/utils/storage.js'
  export default {
    name: "bindCar",
    data() {
      return {
        url: "", //展示图片
        cUrl: "", //点击跳转地址
        isBind: false, //是否有绑定车辆
        isFullBind: true, //是否已绑定三个车牌
        title: "",
        active: "2",
        carNum: "",
        carImgUrl: "../static/img/carBlue.png",
        openid: "",
        carList: []
      };
    },
    methods: {
      //获取绑定车牌号
      getList() {
        this.$http.post(this.$api.myCar + "/" + this.openid, {}).then(res => {
          this.carList = res.data;
          if (res.data.length == 0) {
            this.isBind = true;
            this.isFullBind = true;
          } else {
            this.isBind = false;
            if (res.data.length > 2) {
              this.isFullBind = false;
            } else {
              this.isFullBind = true;
            }
          }
        })
      },
      carFormat(carNum) {
        let car0 = carNum.substring(0, 2);
        let car1 = carNum.substring(2, carNum.length);
        return car0 + "·" + car1;
      },
      bindCar() {
        this.$router.push({
          path: '/bindCar',
          query: {
            openid: this.openid
          }
        });
      },
      relieveBind(id) {
        Dialog.confirm({
            title: '解绑车牌',
            message: '确定解绑该车辆吗？',
          })
          .then(() => {
            this.$http.post(this.$api.relieveBind + "/" + id, {}).then(res => {
              this.getList();
            });
          })
          .catch(() => {});
      },
      getopenId() {
        if (mySessionStorage.getItem("openid") != null && mySessionStorage.getItem("openid") != "" && mySessionStorage.getItem("openid") != "") {
          this.openid = mySessionStorage.getItem("openid");
          this.getList();
        } else {
          this.$getOpenid().then(res => {
            this.openid = mySessionStorage.getItem("openid");
            console.log("--------------------------", this.openid);
            this.getList();
          });

        }
      },
      //广告加载
      getAdvertisingInfo() {
        this.$axios({
            url: this.$api.receipt,
            method: "get",
          })
          .then(res => {
            this.url = res.data.data.creativeImg.creativeUrl;
            this.cUrl = res.data.data.landingPage;
            let trackUrl = res.data.data.trackUrl;
            this.$axios({
              url: trackUrl,
              method: "get",
            }).then(res => {
              console.log(res)
            });
            console.log(res.data);
          })
      },
      clickUrl() {
        window.location.href = this.cUrl;
      }
    },
    created() {},
    mounted() {
      this.getAdvertisingInfo();
      //mySessionStorage.setItem("openid", "o1KC-wsvSK2iAGTF0V-v0iRUmdw0");
      this.getopenId();
    }
  };
</script>

<style scoped>
  .bindCar {
    background-color: #e8e9eb;
    height: 100%;
    width: 100%;
    overflow: scroll;
    height: calc(100vh);
  }

  .bt_bind {
    width: 100%;
    margin-top: 5px;
    border-radius: 5px;
    height: 36px;
  }

  .con {
    padding: 2% 1.5%;
  }

  .div_info {
    padding: 2% 1.5%;
    text-align: center;
    background-color: white;
  }

  .relieve_bind {
    height: 36px;
    border: 1px dashed gray;
    line-height: 32px;
  }

  .info {
    text-align: center;
    height: 36px;
    line-height: 36px;
    color: gray;
  }

  .div_msg {
    text-align: center;
    line-height: 5em;
    color: orangered;
    font-weight: bold;
  }

  .div_left {
    float: left;
  }

  .div_right {
    float: right;
  }

  .div_clear {
    clear: both;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/bind/myCar.vue